export default "__VITE_ASSET__qqg2UJCp__"